import { Trophy, Target, Compass, Zap } from 'lucide-react'

const QUESTIONS = [
  { icon: Trophy, text: 'Did we win the week?' },
  { icon: Target, text: 'Are our priorities on track?' },
  { icon: Compass, text: 'Where do we need to adjust?' },
  { icon: Zap, text: 'What needs our attention now?' },
]

export default function KeyQuestions() {
  return (
    <section>
      <h2 className="text-base font-bold uppercase tracking-widest text-text-muted mb-4 font-sans">
        KEY QUESTIONS
      </h2>
      <div className="flex flex-wrap gap-4">
        {QUESTIONS.map((q) => {
          const Icon = q.icon
          return (
            <div
              key={q.text}
              className="bg-[#F8F9FA] rounded-xl p-5 flex items-center gap-3"
              style={{ flex: '1 1 220px', minWidth: 220 }}
            >
              <div className="w-11 h-11 rounded-lg bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                <Icon className="w-6 h-6 text-text-primary" />
              </div>
              <p className="text-lg font-semibold text-text-primary font-sans">{q.text}</p>
            </div>
          )
        })}
      </div>
    </section>
  )
}
